import { render, staticRenderFns } from "./CompanyModal.vue?vue&type=template&id=1865fd20"
import script from "./CompanyModal.vue?vue&type=script&lang=js"
export * from "./CompanyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1865fd20')) {
      api.createRecord('1865fd20', component.options)
    } else {
      api.reload('1865fd20', component.options)
    }
    module.hot.accept("./CompanyModal.vue?vue&type=template&id=1865fd20", function () {
      api.rerender('1865fd20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/CompanyModal.vue"
export default component.exports